import { valOr, isObject } from '../SharedUtils.js'

/**
 * Utility class to traverse the object hierarchy, calling a visitor function on each object.
 * Paths are built from property keys and array indices.
 */
export class ObjectVisitor {
  constructor(parentObj, opts) {
    this.parentObj = parentObj;
    if (!this._implementsTraversal(parentObj)) {
      throw new Error(`ObjectVisitor: parentObj must implement traversal: ${parentObj}`);
    }
    this.opts = valOr(opts, {});
  }

  visit(visitorFunc) {
    this._visitRecursive(this.parentObj, visitorFunc, new Set(), '');
  }

  _implementsTraversal(obj) {
    return isObject(obj) && obj.childObjs;
  }

  _visitRecursive(parentObj, visitorFunc, visited, curPath) {
    if (visited.has(parentObj)) {
      return;
    }
    visited.add(parentObj);

    visitorFunc(parentObj, { curPath });

    if (parentObj.childObjs == '$none') {
      return;
    } else if (parentObj.childObjs == '$auto') {
      for (const key of Object.keys(parentObj)) {
        const childObj = parentObj[key];
        if (this._implementsTraversal(childObj) && childObj.enabled !== false) {
          this._visitRecursive(childObj, visitorFunc, visited, `${curPath}/${key}`);
        } else if (Array.isArray(childObj)) {
          for (let i = 0; i < childObj.length; ++i) {
            const elem = childObj[i];
            if (this._implementsTraversal(elem) && elem.enabled !== false) {
              this._visitRecursive(elem, visitorFunc, visited, `${curPath}/${key}[${i}]`);
            }
          }
        }
      }
    } else {
      throw new Error(`Unexpected value for 'childObjs': '${parentObj.childObjs}'`);
    }
  }
}
